import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import LessonPlan from '@/models/LessonPlan';
import { BaseFilters } from '@/models/Service';
import notImplementedEndpoint from '@/utils/notImplementedEndpoint';

const BASE_URL = 'lesson-plans';

export type ListLessonPlanFilters = BaseFilters & {
  coursePathId?: number[];
  courseLessonPlanId?: number[];
};

export type LessonPlanOrder = {
  id: number;
  itemsIds: Array<{ id: number }>;
};

export const listLessonPlans = async (filters: ListLessonPlanFilters = {}) => {
  const { data } = await requester().get<JsonApiResponse<LessonPlan>>(
    `${BASE_URL}/`,
    { params: filters },
  );
  return data;
};

export const createLessonPlan = async (body: Partial<LessonPlan>) => {
  const { data } = await requester().post<LessonPlan>(`${BASE_URL}/`, body);
  return data;
};

export const updateLessonPlan = async (
  lessonPlanId: number,
  body: Partial<LessonPlan>,
) => {
  const { data } = await requester().patch<LessonPlan>(
    `${BASE_URL}/${lessonPlanId}/`,
    body,
  );
  return data;
};

export const removeLessonPlan = async (lessonPlanId: number) => {
  await requester().delete<void>(`${BASE_URL}/${lessonPlanId}/`);
};

export const updateLessonPlansOrder = async (_order: LessonPlanOrder[]) => {
  return notImplementedEndpoint(
    `PATCH ${BASE_URL}/order/ is not implemented yet`,
  );
};
